import { FunctionComponent } from 'react'
import Dialog from '@/components/_custom/Dialog/Dialog.tsx'
import { useTranslation } from 'react-i18next'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader.tsx'
import DialogBody from '@/components/_custom/DialogBody/DialogBody.tsx'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon.tsx'
import { Close, Delete } from '@mui/icons-material'
import { useMutation } from '@apollo/client'
import { MealTexture } from '@/types/Meal.ts'
import { DELETE_DAYCARE_MEAL_TEXTURE } from '@/modules/API/meal/daycareSettingsHandler.ts'
import { useNotification } from '@/modules/context/NotificationContext.tsx'
import styles from '../meal.module.scss'

interface ConfirmDeleteMealTextureDialogProps {
    open: boolean
    handleClose: () => void
    daycareId: number
    texture: MealTexture
    refetch: () => void
}

const ConfirmDeleteMealTextureDialog: FunctionComponent<ConfirmDeleteMealTextureDialogProps> = ({
    open,
    handleClose,
    daycareId,
    texture,
    refetch
}: ConfirmDeleteMealTextureDialogProps) => {
    const { t } = useTranslation()
    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [deleteMealTexture] = useMutation(DELETE_DAYCARE_MEAL_TEXTURE, {
        variables: {
            daycareId,
            id: texture.id
        },
        onCompleted: () => {
            refetch()
            showNotificationSuccess(t('mealTextureDeleted'))
            handleClose()
        },
        onError: () => {
            showNotificationError(t('mealTextureDeletedError'))
            handleClose()
        }
    })

    return (
        <Dialog open={open} handleClose={handleClose}>
            <DialogHeader title={t('deleteMealTexture')} />
            <DialogBody className={styles.DialogBody}>
                <div className={styles.TextContainer}>
                    <p className={styles.Text}>
                        {t('deleteMealTextureMessage')} <span>{texture.texture}</span> ?{' '}
                    </p>
                    <p className={styles.Text}>{t('noRollBack')}</p>
                </div>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('yes')}
                        customIcon={<Delete />}
                        onClick={() => deleteMealTexture()}
                        className={styles.Button}
                    />
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('no')}
                        customIcon={<Close />}
                        onClick={handleClose}
                        className={styles.Button}
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default ConfirmDeleteMealTextureDialog
